import { render, staticRenderFns } from "./reply.component.html?vue&type=template&id=5b4ebd87&scoped=true&"
import script from "./reply.component.ts?vue&type=script&lang=ts&"
export * from "./reply.component.ts?vue&type=script&lang=ts&"
import style0 from "./reply.component.scss?vue&type=style&index=0&id=5b4ebd87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4ebd87",
  null
  
)

export default component.exports